var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutSmallIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8333 15.6666L22.5 11M22.5 11L17.8333 6.33329M22.5 11H6.16667M13.1667 15.6666V16.8333C13.1667 17.7615 12.7979 18.6518 12.1415 19.3082C11.4852 19.9645 10.5949 20.3333 9.66667 20.3333H5C4.07174 20.3333 3.1815 19.9645 2.52513 19.3082C1.86875 18.6518 1.5 17.7615 1.5 16.8333V5.16663C1.5 4.23837 1.86875 3.34813 2.52513 2.69175C3.1815 2.03537 4.07174 1.66663 5 1.66663H9.66667C10.5949 1.66663 11.4852 2.03537 12.1415 2.69175C12.7979 3.34813 13.1667 4.23837 13.1667 5.16663V6.33329",
    stroke: "#121212",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutSmallIcon);
export default __webpack_public_path__ + "static/media/LogoutSmallIcon.4ebf00b76af01ab9094cf1a8a4cf98e8.svg";
export { ForwardRef as ReactComponent };